import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'

import CardProperty from 'Components/CardProperty'
import Permissions from 'Components/Permissions'

import * as helpers from 'Global/Helpers/rugHelpers'
import { getFormattedDateString } from 'Global/Helpers/timeHelpers'

const RugCardDetailedInformation = ({ rug }) => {
  return (
    <Permissions
      permissions={[
        'rug.field.dateOrder',
        'rug.field.dateReceipt',
        'rug.field.edges',
        'rug.field.quality',
        'rug.field.producerCode',
        'rug.field.size',
      ]}
      render={() => (
        <Card.Content extra>
          <List>
            {rug.sizeH && rug.sizeW && (
              <Permissions
                permissions="rug.field.size"
                render={() => (
                  <CardProperty icon="expand" popUpContent="Size">
                    {`${rug.sizeW}cm x ${rug.sizeH}cm (${rug.sizeQm}qm)`}
                  </CardProperty>
                )}
              />
            )}

            {rug.knotDescription && (
              <Permissions
                permissions="rug.field.quality"
                render={() => (
                  <CardProperty icon="share alternate" popUpContent="Quality">
                    {rug.knotDescription}
                  </CardProperty>
                )}
              />
            )}

            {rug.dessin && (
              <Permissions
                permissions="rug.field.edges"
                render={() => (
                  <CardProperty icon="block layout" popUpContent="Edges">
                    {helpers.getDessinName(parseInt(rug.dessin, 10))}
                  </CardProperty>
                )}
              />
            )}

            {rug.producerCode && (
              <Permissions
                permissions="rug.field.producerCode"
                render={() => (
                  <CardProperty icon="factory" popUpContent="Producer">
                    {rug.producerCode}
                  </CardProperty>
                )}
              />
            )}

            {rug.dateOrder && (
              <Permissions
                permissions="rug.field.dateOrder"
                render={() => (
                  <CardProperty icon="calendar" popUpContent="Date Order">
                    {getFormattedDateString(rug.dateOrder)}
                  </CardProperty>
                )}
              />
            )}

            {rug.dateReceipt && (
              <Permissions
                permissions="rug.field.dateReceipt"
                render={() => (
                  <CardProperty icon="add to calendar" popUpContent="Date Receipt">
                    {getFormattedDateString(rug.dateReceipt)}
                  </CardProperty>
                )}
              />
            )}
          </List>
        </Card.Content>
      )}
    />
  )
}

RugCardDetailedInformation.propTypes = {
  rug: PropTypes.object.isRequired,
}

export default RugCardDetailedInformation
